export const WIDGET_CONSTANTS = {
  //This list will be extended with variable types in baseService
  EVENTS: {
    'NO_EVENT': 'No Event',
    'JAVASCRIPT': 'Javascript',
    'STOP_PROPAGATION': 'Stop Propagation',
    'STOP_PROP_FN': '$event.stopPropagation()'
  },
  EVENTS_OPTIONS: ['No Event', 'Javascript', 'Stop Propagation','New Variable','New Action'],
  NAVIGATION_TYPE: {
    'BASIC'    : 'Basic',
    'CLASSIC'  : 'Classic',
    'ADVANCED' : 'Advanced',
    'SCROLL'   : 'Scroll',
    'INLINE'   : 'Inline',
    'PAGER'    : 'Pager',
    'ONDEMAND' : 'On-Demand'
  }
}

// set of boolean attrs
export const BOOLEAN_ATTRS = new Set([
    'readonly', 'autofocus', 'disabled', 'startchecked', 'multiple',
    'selected', 'required', 'controls', 'autoplay', 'loop', 'muted', 'show'
]);

export const PROJECT_ID_PARAM_NAME = 'project-id';
export const CONSTANTS = {
  DEFAULT_THEME: 'default',
  DEFAULT_MOBILE_THEME: 'mobile',
  CHARACTERS_LIMIT: {
    PAGE_NAME: 32,
    VARIABLE_NAME: 50
 }
};

export const DEPRECATED_THEMES: string[] = ['graffiti', 'mellow-yellow', 'autumn', 'cool-blue', 'flyer', 'retro', 'vermillion', 'neon'];

export const DOC_LINKS = {
  THEME_HELP_LINK     : 'https://docs.wavemaker.com/learn/app-development/ui-design/themes/#custom-themes',
  OBSELETE_THEME_INFO : 'https://docs.wavemaker.com/learn/app-development/ui-design/themes/',
  RE_IMPORT_API_LINK : 'https://docs.wavemaker.com/learn/app-development/services/api-designer/reimport-rest-apis-swagger/'
}

export const WM_ACADEMY_LINK = "https://academy.wavemaker.com/";

export const DEFAULT_PROJECT_SHELL_NAMES = {
  'DEFAULT': 'default',
  'PREFAB' : 'prefab',
  'ESHOP'  : 'eshop'
}


export const OPERATIONS = ["get", "post", "put", "patch", "delete", "head", "options"]

export const  ROUTE_CONSTANTS= {
  PROJECTS_LIST: "/projects",
  USERS_LIST: "/users",
  USER_PROFILE: "/user/profile/:path",
  USER_PROFILE_DEFAULT: "/user/profile/update-profile",
  USER_PROFILE_CLOUD: "/user/profile/cloud",
  USER_CHANGE_PASSWORD: "/user/change-password",
  USER_UPDATE_PROFILE: "/user/update-profile",
  SUBSCRIPTIONS: "/subscriptions/app/main.html#/account/profile",
  ACCOUNTS: "/user/accounts",
  LOGOUT: "/logout",
  PROJECT_STATUS: "/projectstatus/:status"
}

export const TOKEN_MODES = {
  DARK: 'dark',
  LIGHT: 'light',
  DEFAULT: 'default',
};

export const TOKEN_TYPES = {
  COLOR: 'color',
  SIZE: 'size',
  STYLE: 'style',
  TEXT: 'text',
  OTHERS: 'others'
};
export const TOKEN_CATEGORIES = {
  COLOR: 'color',
  FONT: 'font',
  OPACITY: 'opacity',
  RADIUS: 'radius',
  SPACE: 'space',
  ICONS: 'icon',
  ELEVATION: 'elevation',
  BORDER: 'border',
  BORDERSTYLE: 'borderStyle'
};

export const TOKENS_KEYS = {
  STANDARD: 'standard',
  DEFAULT: 'default',
  VARIANT_GROUPS: 'variantGroups',
  APPEARANCES: "appearances",
  MAPPING: "mapping",
  STATES: 'states'
};

export const PRESET_COLORS = [
  '#1677ff', // Vivid Blue
  '#722ed1', // Deep Purple
  '#13c2c2', // Aqua Blue
  '#52c41a', // Fresh Green
  '#eb2f96', // Pink Rose
  '#f5222d', // Bright Red
  '#fa8c16', // Vibrant Orange
  '#fadb14', // Sunny Yellow
  '#fa541c', // Fiery Orange
  '#2f54eb', // Royal Blue
  '#faad14', // Golden Yellow
  '#a0d911', // Lime Green
  '#000000', // Pure Black
];

export const DESIGN_TOKENS_DIR_NAME = "design-tokens";
export const APP_OVERRIDE_CSS_PATH = `${DESIGN_TOKENS_DIR_NAME}/app.override.css`;
export const APP_STUDIO_OVERRIDE_CSS_PATH = `${DESIGN_TOKENS_DIR_NAME}/app.studio.override.css`;
export const OVERRIDE_TOKENS_PATH = `${DESIGN_TOKENS_DIR_NAME}/overrides`;

export const ENUM_CATEGORIES = {
  "text-transform": [
    { value: "none", subtype: "text-transform", text: "None" },
    { value: "capitalize", subtype: "text-transform", text: "Capitalize" },
    { value: "uppercase", subtype: "text-transform", text: "Uppercase" },
    { value: "lowercase", subtype: "text-transform", text: "Lowercase" },
    { value: "full-width", subtype: "text-transform", text: "Full-width" },
    { value: "inherit", subtype: "text-transform", text: "Inherit" },
    { value: "initial", subtype: "text-transform", text: "Initial" },
    { value: "unset", subtype: "text-transform", text: "Unset" }
  ],
  
  "text-decoration": [
    { value: "none", subtype: "text-decoration", text: "None" },
    { value: "underline", subtype: "text-decoration", text: "Underline" },
    { value: "overline", subtype: "text-decoration", text: "Overline" },
    { value: "line-through", subtype: "text-decoration", text: "Line-through" },
    { value: "blink", subtype: "text-decoration", text: "Blink" },
    { value: "inherit", subtype: "text-decoration", text: "Inherit" },
    { value: "initial", subtype: "text-decoration", text: "Initial" },
    { value: "unset", subtype: "text-decoration", text: "Unset" }
  ],
  
  "pointer-events": [
    { value: "auto", subtype: "pointer-events", text: "Auto" },
    { value: "none", subtype: "pointer-events", text: "None" },
    { value: "visiblePainted", subtype: "pointer-events", text: "Visible Painted" },
    { value: "visibleFill", subtype: "pointer-events", text: "Visible Fill" },
    { value: "visibleStroke", subtype: "pointer-events", text: "Visible Stroke" },
    { value: "visible", subtype: "pointer-events", text: "Visible" },
    { value: "painted", subtype: "pointer-events", text: "Painted" },
    { value: "fill", subtype: "pointer-events", text: "Fill" },
    { value: "stroke", subtype: "pointer-events", text: "Stroke" },
    { value: "all", subtype: "pointer-events", text: "All" },
    { value: "inherit", subtype: "pointer-events", text: "Inherit" },
    { value: "initial", subtype: "pointer-events", text: "Initial" },
    { value: "unset", subtype: "pointer-events", text: "Unset" }
  ],
  
  "cursor": [
    { value: "auto", subtype: "cursor", text: "Auto" },
    { value: "default", subtype: "cursor", text: "Default" },
    { value: "pointer", subtype: "cursor", text: "Pointer" },
    { value: "crosshair", subtype: "cursor", text: "Crosshair" },
    { value: "move", subtype: "cursor", text: "Move" },
    { value: "text", subtype: "cursor", text: "Text" },
    { value: "wait", subtype: "cursor", text: "Wait" },
    { value: "help", subtype: "cursor", text: "Help" },
    { value: "not-allowed", subtype: "cursor", text: "Not Allowed" },
    { value: "progress", subtype: "cursor", text: "Progress" },
    { value: "grab", subtype: "cursor", text: "Grab" },
    { value: "grabbing", subtype: "cursor", text: "Grabbing" },
    { value: "inherit", subtype: "cursor", text: "Inherit" },
    { value: "initial", subtype: "cursor", text: "Initial" },
    { value: "unset", subtype: "cursor", text: "Unset" }
  ]
};

export const CACHE_TO_SUBTYPE_MAP : any = {
  "borderStyle" : "border-style", 
  "icon" : "icon-size", 
  "border" : "border-width", 
}
